/**
 * @file globalErrorHandler.js
 * @description Tratamento global de erros não capturados
 */

import { isProduction } from './environment';

/**
 * @function initGlobalErrorHandlers
 * @description Inicializa tratadores globais de erro
 */
export const initGlobalErrorHandlers = () => {
  // Captura erros não tratados do JavaScript
  window.addEventListener('error', (event) => {
    console.error('❌ Erro global capturado:', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error
    });

    // Em produção, SEMPRE evita que o erro quebre a aplicação
    if (isProduction()) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    return true;
  });

  // Captura rejeições de Promise não tratadas
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const isAbort =
      reason?.name === 'AbortError' ||
      reason?.code === 'ERR_CANCELED' ||
      reason?.aborted === true;

    if (isAbort) {
      event.preventDefault();
      return true;
    }

    console.error('❌ Promise rejeitada não tratada:', {
      reason: event.reason,
      promise: event.promise
    });

    // Em produção, SEMPRE evita que o erro quebre a aplicação
    if (isProduction()) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    return true;
  });

  // Sobrescreve console.error para capturar erros do MUI e outros
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const errorMessage = args.join(' ');
    
    const ignoredPatterns = [
      'Warning: Failed prop type: Invalid prop `error`',
      'Warning: Failed prop type: Invalid prop `focused`',
      'Warning: React does not recognize the `helperText` prop',
      'Warning: Each child in a list should have a unique "key"',
      'Warning: Received `false` for a non-boolean attribute',
      'Warning: Invalid prop `error` of type',
      'Warning: Invalid prop `focused` of type',
      'Warning: Invalid prop `disabled` of type',
      'MuiOutlinedInputInput contains an input',
      'defaultValue',
      'value and defaultValue'
    ];

    const shouldIgnore = ignoredPatterns.some(pattern => 
      errorMessage.includes(pattern)
    );

    if (shouldIgnore) {
        if (!isProduction()) {
          if (!window.__muiWarningsShown) {
            window.__muiWarningsShown = new Set();
          }
          
          const warningType = ignoredPatterns.find(p => errorMessage.includes(p));
          if (warningType && !window.__muiWarningsShown.has(warningType)) {
            originalConsoleError.apply(console, [
              `⚠️ MUI Warning (mostrado apenas 1x):`,
              ...args
            ]);
            window.__muiWarningsShown.add(warningType);
          }
        }
        return;
    }

      originalConsoleError.apply(console, args);

      if (isProduction()) {
      }
  };

  console.log('✅ Tratadores globais de erro inicializados');
  console.log('🛡️ Aplicação protegida contra erros em produção');
};

/**
 * @function removeGlobalErrorHandlers
 * @description Remove tratadores globais de erro
 */
export const removeGlobalErrorHandlers = () => {
  window.removeEventListener('error', () => {});
  window.removeEventListener('unhandledrejection', () => {});
};

